export default "__VITE_ASSET__lUBbK7Ma__"